// Static placeholder content for the premium Quanticom redesign.
// Dynamic content (hero copy, services list, contact info) still comes from /api/content.

export const IMAGES = {
  heroBackground:
    "https://images.unsplash.com/photo-1767047222492-15b36d4b3dcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHx0ZWxlY29tbXVuaWNhdGlvbnMlMjB0b3dlciUyMGR1c2t8ZW58MHx8fHwxNzgxNjY4MzY2fDA&ixlib=rb-4.1.0&q=85",
  networkNodes:
    "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG5ldHdvcmslMjBub2RlcyUyMGNvbm5lY3Rpb258ZW58MHx8fHwxNzgxNjY4Mzc4fDA&ixlib=rb-4.1.0&q=85",
  workers:
    "https://images.unsplash.com/photo-1639070882750-99dd6ba7dff6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJzJTIwZGFyayUyMHNpbGhvdWV0dGV8ZW58MHx8fHwxNzgxNjY4MzY2fDA&ixlib=rb-4.1.0&q=85",
  fiber:
    "https://images.unsplash.com/photo-1606814540563-5c02d62fd409?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxmaWJlciUyMG9wdGljJTIwY2FibGVzJTIwZ2xvd2luZ3xlbnwwfHx8fDE3ODE2NjgzNjZ8MA&ixlib=rb-4.1.0&q=85",
  dataCenter:
    "https://images.pexels.com/photos/5203849/pexels-photo-5203849.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  rigger:
    "https://images.unsplash.com/photo-1681194179636-52249feaeb5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHx0ZWxlY29tJTIwdG93ZXIlMjByaWdnZXIlMjBjbGltYmluZyUyMHNhZmV0eSUyMGdlYXJ8ZW58MHx8fHwxNzczMTgxNTEzfDA&ixlib=rb-4.1.0&q=85",
  civil:
    "https://images.unsplash.com/photo-1596112821147-f7b07d90fc1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxleGNhdmF0b3IlMjBjaXZpbCUyMHdvcmtzJTIwcm9hZCUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3NzMxODE1MjJ8MA&ixlib=rb-4.1.0&q=85",
  team:
    "https://images.unsplash.com/photo-1761227447538-f4e1ec0a9df6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBzYWZldHklMjB2ZXN0JTIwaGFyZCUyMGhhdCUyMHRlYW18ZW58MHx8fHwxNzczMTgxNTQyfDA&ixlib=rb-4.1.0&q=85",
};

export const HERO_STATS = [
  { value: 3, suffix: "", label: "Qualified Telecommunications Specialists" },
  { value: 4, suffix: "", label: "Service Vehicles" },
  { value: 3, suffix: "", label: "Years Operating" },
  { value: 0, suffix: "", label: "Emergency Response Capability", display: "24/7" },
];

// Industry Experience — factual capability areas
export const EXPERIENCE_AREAS = [
  { title: "Fibre Network Construction", icon: "git-merge" },
  { title: "Fibre Splicing & Testing", icon: "waypoints" },
  { title: "Copper Infrastructure", icon: "cable" },
  { title: "Wireless Infrastructure", icon: "radio-tower" },
  { title: "Tower Rigging", icon: "tower-control" },
  { title: "Antenna Installation", icon: "antenna" },
  { title: "Telecommunications Maintenance", icon: "wrench" },
  { title: "Fault Response", icon: "siren" },
  { title: "NBN Projects", icon: "network" },
  { title: "Network Audits & Surveys", icon: "clipboard-check" },
];

// How We Deliver — 5-step delivery process
export const DELIVERY_STEPS = [
  { step: "01", title: "Site Assessment", icon: "search", text: "On-site inspection and scoping to understand the environment, access and technical requirements." },
  { step: "02", title: "Planning & Safety Compliance", icon: "shield-check", text: "Detailed planning, JSAs/SWMS and compliance checks before any work begins on site." },
  { step: "03", title: "Installation & Construction", icon: "hard-hat", text: "Hands-on construction, rigging, cabling and installation delivered to carrier standards." },
  { step: "04", title: "Testing & Commissioning", icon: "activity", text: "Thorough testing, fault rectification and commissioning to verify performance and quality." },
  { step: "05", title: "Handover & Documentation", icon: "file-text", text: "Complete as-built documentation, test results and a clean, compliant handover." },
];

export const SERVICES = [
  {
    id: "tower-rigging",
    title: "Tower Rigging",
    icon: "tower-control",
    description:
      "Certified riggers and dogging crews for tower climbs, antenna mounts and structural works at height.",
  },
  {
    id: "wireless-infrastructure",
    title: "Wireless Infrastructure",
    icon: "radio-tower",
    description:
      "End-to-end 4G/5G site builds, small cells and microwave links engineered for performance and uptime.",
  },
  {
    id: "fibre-networks",
    title: "Fibre Networks",
    icon: "git-merge",
    description:
      "FTTP/FTTN/FTTB design, splicing, hauling and OTDR testing for resilient national fibre backbones.",
  },
  {
    id: "telecommunications-maintenance",
    title: "Telecommunications Maintenance",
    icon: "wrench",
    description:
      "Proactive and reactive maintenance programs keeping carrier networks online 24/7.",
  },
  {
    id: "site-audits",
    title: "Site Audits & Inspections",
    icon: "clipboard-check",
    description:
      "Detailed structural, RF and safety audits with compliant reporting and remediation planning.",
  },
  {
    id: "project-delivery",
    title: "Project Delivery",
    icon: "layout-grid",
    description:
      "Turnkey project management from scoping and design through to handover and as-builts.",
  },
];

export const WHY_CHOOSE = [
  { title: "Safety First", icon: "shield-check", text: "Zero-harm culture with rigorous JSAs, SWMS and ongoing safety leadership." },
  { title: "Certified Workforce", icon: "badge-check", text: "Fully ticketed riggers, doggers, splicers and EWP operators across the country." },
  { title: "Industry Experience", icon: "award", text: "15+ years delivering for Australia's largest carriers and infrastructure builders." },
  { title: "Rapid Deployment", icon: "zap", text: "Mobilised crews and fleet ready to respond at speed, anywhere nationwide." },
  { title: "Australia-Wide Coverage", icon: "map", text: "Metro and regional capability spanning every state and territory." },
  { title: "Quality Assurance", icon: "check-circle", text: "ISO-aligned QA processes with full documentation and verifiable as-builts." },
];

export const CERTIFICATIONS = [
  "Working at Heights",
  "Rigging Basic",
  "Dogging",
  "EWP",
  "First Aid & CPR",
  "Confined Space",
  "Gas Atmospheres",
];

export const PROJECT_CATEGORIES = ["All", "Rigging", "Wireless", "Fibre", "Civil", "Maintenance"];

// PROJECTS intentionally empty — to be populated with real project data & photography when available.
export const PROJECTS = [];

export const EQUIPMENT = [
  { title: "Fleet Vehicles", image: "civil", text: "Fully equipped service vehicles, EWPs and heavy plant ready to mobilise nationwide." },
  { title: "Rigging Equipment", image: "rigger", text: "Certified rigging gear, rope-access systems and lifting equipment for works at height." },
  { title: "Fibre Testing Equipment", image: "fiber", text: "Fusion splicers, OTDRs, power meters and light sources for full fibre certification." },
  { title: "Safety Equipment", image: "workers", text: "Premium PPE, fall-arrest and confined-space gear backed by a zero-harm safety system." },
];

// TESTIMONIALS intentionally empty — no fabricated client reviews. Add real, attributable testimonials when available.
export const TESTIMONIALS = [];

// Trusted-by partner logo placeholders (text marks until real logos provided)
export const PARTNERS = [
  "Telstra",
  "Optus",
  "Vodafone",
  "TPG",
  "NBN Co",
  "Ventia",
  "Service Stream",
  "Downer",
];

// Capability statement cards
export const CAPABILITIES = [
  { title: "Tower Rigging", icon: "tower-control" },
  { title: "Wireless Infrastructure", icon: "radio-tower" },
  { title: "Fibre Networks", icon: "git-merge" },
  { title: "Maintenance", icon: "wrench" },
  { title: "Emergency Response", icon: "siren" },
  { title: "NBN Projects", icon: "network" },
  { title: "Site Audits", icon: "clipboard-check" },
];

// Meet the team — real profiles (photos to be added)
export const TEAM = [
  {
    name: "Avtar Brar",
    role: "Working Director & Telecommunications Infrastructure Specialist",
    initials: "AB",
    skills: ["Fibre Networks", "Copper Infrastructure", "Wireless Infrastructure", "Telecommunications Rigging", "Project Delivery"],
  },
  {
    name: "Jasvir Singh",
    role: "Working Director & Telecommunications Infrastructure Specialist",
    initials: "JS",
    skills: ["Fibre Networks", "Copper Infrastructure", "Wireless Infrastructure", "Telecommunications Rigging", "Network Maintenance"],
  },
  {
    name: "Arashdeep Singh",
    role: "Telecommunications Infrastructure Specialist",
    initials: "AS",
    skills: ["Fibre Networks", "Copper Infrastructure", "Wireless Infrastructure", "Telecommunications Rigging", "Maintenance & Fault Response"],
  },
];

export const COMBINED_CAPABILITY = [
  "Fibre Networks",
  "Copper Infrastructure",
  "Wireless Infrastructure",
  "Telecommunications Rigging",
  "Tower Climbing",
  "Antenna Installation",
  "NBN Projects",
  "Maintenance & Fault Response",
  "Testing & Commissioning",
  "Site Audits & Surveys",
];

// Company / legal details
export const COMPANY = {
  abn: "90 902 608 474",
  acn: "902 608 474",
  serviceAreas: "Australia-wide delivery",
  serviceAreaList: ["Australia-wide"],
  capabilityPdf: "/Quanticom-Capability-Statement.pdf",
  linkedin: "https://www.linkedin.com",
};

